<template lang="pug">
  div
    router-view
</template>

<script>
export default {
  name: 'AccessLog',
  beforeRouteLeave (to, from, next) {
    // sessionStorageを初期化する
    this.resetSession()

    next()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/admin/accesslog/Index.vue